import {
    format as formatWithTimezone,
    formatInTimeZone,
    toZonedTime,
} from 'date-fns-tz';
import {
    format as formatWithoutTimezone,
    formatDistanceToNow as formatDistanceToNowWithoutTimezone,
    parseISO,
} from 'date-fns';

export const formatFixedTime = function (date, format) {
    return formatWithTimezone(
        toZonedTime(
            dateInstance(date), 'UTC'),
        format,
        {timeZone: 'UTC'},
    );
};

export const formatTime = function (date, format) {
    return formatWithoutTimezone(
        dateInstance(date),
        format,
    );
};

export const formatTimeInTimezone = function (date, timezone, format) {
    return formatInTimeZone(
        dateInstance(date),
        timezone,
        format,
    );
};

export const formatDistanceToNow = function (date, options) {
    return formatDistanceToNowWithoutTimezone(
        dateInstance(date),
        options,
    );
};

export const formatFixedDistanceToNow = function (date, options) {
    return formatDistanceToNowWithoutTimezone(
        dateInstance(date),
        options,
    );
};

export const shortTimezone = function (date, timezone = null, locale = null) {
    if (timezone === null) {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    const parts = new Intl.DateTimeFormat(locale ?? 'en-AU', {
        timeZone:     timezone,
        timeZoneName: 'short',
    }).formatToParts(dateInstance(date));

    return parts.find(part => part.type === 'timeZoneName')?.value;
};

export const dateInstance = function (date) {
    return date instanceof Date ? date : parseISO(date);
};

export default {
    methods: {
        formatFixedTime,
        formatTime,
        formatTimeInTimezone,
        formatDistanceToNow,
        formatFixedDistanceToNow,
        shortTimezone,
    },
};